export class CriterionDetailsDialogViewModel
{
    opened: boolean = false;
    name: string = null;
    path: string = null;
    description: string = null;


    show(name: string, path: string, description: string)
    {
        this.name = name;
        this.path = path;
        this.description = description;

        this.opened = true;

    }

    close()
    {
        this.opened = false;
        this.name = null;
        this.description = null;
        this.path = null;
    }
}